const _excluded = ["checked", "disabled", "defaultChecked", "label", "onChange"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { cx } from "../../helpers/utils/cx";
import { mergeRefs } from "../../helpers/utils/mergeRefs";
export const Switch = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const internalRef = /*#__PURE__*/React.createRef();
  const {
      checked,
      disabled = false,
      defaultChecked,
      label,
      onChange
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const handleKeyDown = React.useCallback(e => {
    if (e.key === "Enter") {
      e.target.dispatchEvent(new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true
      }));
    }
  }, []);
  const switchElement = /*#__PURE__*/React.createElement("span", {
    className: cx("w-12 h-8 inline-block relative shrink-0")
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    role: "switch",
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    onChange: onChange,
    onKeyPress: handleKeyDown,
    ref: mergeRefs([internalRef, forwardedRef])
  }, rest, {
    className: cx("peer", ["w-full h-full appearance-none cursor-pointer bg-transparent disabled:cursor-default m-0 rounded-full"])
  })), /*#__PURE__*/React.createElement("span", {
    className: cx("absolute inset-0 rounded-full", "transition-colors ease-linear duration-200", "pointer-events-none", "bg-neutral-secondary-hard", "peer-hover:bg-active-neutral-secondary-hard", "peer-checked:bg-action-primary", "peer-checked:peer-hover:bg-active-action-primary", "peer-disabled:bg-special-disabled", "peer-disabled:peer-hover:bg-special-disabled")
  }), /*#__PURE__*/React.createElement("span", {
    className: cx("w-6 h-6 absolute inset-1 rounded-full", "bg-static-key-light shadow-md", "peer-disabled:shadow-none", "pointer-events-none", "ease-in-out duration-200 transform", "peer-checked:translate-x-4 rtl:peer-checked:-translate-x-4")
  }));
  if (label) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/label-has-associated-control -- guaranteed to have control element
      React.createElement("label", {
        className: cx("bolt-font-body-m-regular text-primary leading-loose inline-flex gap-2 cursor-pointer", disabled && "cursor-default text-secondary")
      }, switchElement, label)
    );
  }
  return switchElement;
});